import React from 'react'

const Socials = () => {
  return (
    <div className="home__social">
      <a href="https://www.instagram.com/" className="home__social-icon">
        <i className="uil uil-instagram"></i>
      </a>
      <a href="https://www.facebook.com/" className="home__social-icon">
        <i className="uil uil-facebook"></i>
      </a>
      <a href="https://www.twitter.com/" className="home__social-icon">
        <i className="uil uil-twitter"></i>
      </a>
    </div>
  )
}

export default Socials